export function setReverseLookups(state, { coordinates, address }) {
  state.reverseLookups = Object.freeze({
    ...state.reverseLookups,
    [coordinates]: address,
  });
}
